import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import RewardKeysEffect from '../../../Prototype/Effect/RewardKeysEffect';
import TransformComponent from '../../../Component/Transform';
import { delay } from '../../../Utility/Task/TaskQueue';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import ElementComponent from '../../../Component/UI/Element';

import RewardTextEffect from '../../../Prototype/Effect/RewardTextEffect';
import Game from '../../../Game';
import { DragonbonesAnimationEvent } from '../../../Component/Dragonbones';
import UITextComponent from '../../../Component/UI/Text';
import { StartAudio } from '../../Audio/AudioHelper';
import { AUDIO_UI_KEYS } from '../../Audio';
import { AudioTrackType } from '../../Audio/AudioClip';
import Scene from '../../../Scene/Scene';

interface IRewardKeysData {
    keys: number;
    previousKeys: number;
    scene: Scene;
}

export class RewardKeys extends AnimationClip {
    public *execute(
        animator: GameObject,
        meta: IRewardKeysData
    ): IterableIterator<number> {
        animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

        const keysPanel: GameObject = this.getGameObject('key_hunt');
        if (!keysPanel) return;

        const rewardEffect: GameObject = GameObject.Instantiate(
            RewardKeysEffect,
            {
                keys: [2, 3, 5, 7].find((v, i) => v >= meta.keys || i === 3),
            }
        );
        keysPanel.addChild(rewardEffect);
        animator.addChild(rewardEffect);

        const rewardTransform: TransformComponent = rewardEffect.getComponent(
            TransformComponent
        );
        rewardTransform.x += 510;
        rewardTransform.y += 353;

        const localeText = `+${Game.locale.getText('RewardKeys')}`;
        animator.addChild(
            GameObject.Instantiate(RewardTextEffect, {
                text: localeText.replace('[x]', meta.keys.toString()),
                position: rewardTransform.position.clone(),
            })
        );

        let isPlaying: boolean = true;
        rewardEffect.on(DragonbonesAnimationEvent.COMPLETE, () => {
            rewardEffect.destroy();
            isPlaying = false;
        });

        yield* delay(900);

        StartAudio(meta.scene, AUDIO_UI_KEYS, AudioTrackType.SFX);

        // prettier-ignore
        const keyHuntBar: GameObject = this.getGameObject('key_hunt_progress_bar');
        if (!keyHuntBar) return;

        // Update progress bar and text.
        const barElement: ElementComponent = keyHuntBar.getComponent(
            ElementComponent
        );

        // prettier-ignore
        const keyHuntTxt: GameObject = this.getGameObject('key_hunt_progress_text');
        if (!keyHuntTxt) return;

        const txtElement = keyHuntTxt.getComponent(UITextComponent);

        const progressTween = this.getTween({ progress: meta.previousKeys });
        progressTween
            .to({ progress: meta.previousKeys + meta.keys }, 500)
            .onUpdate(t => {
                const key = Math.min(t.progress, 20);
                barElement.scale.x = key / 20;
                txtElement.text = `${Math.round(key)}/20`;
            });

        yield* this.startTween(progressTween);

        while (isPlaying) yield;
    }

    private getGameObject(key: string): GameObject {
        const array: GameObject[] = GameObject.findByName(key);
        if (!array || array.length === 0) return;
        if (!array[0] || array[0].destroyed) return;
        return array[0];
    }
}
